export const ROLE_PERMS = {
  owner: ["*"],
  manager: ["sell", "customers", "inventory", "purchases", "marketing", "reports", "returns", "clinic", "patients", "cameras"],
  cashier: ["sell", "customers", "cameras"],
  doctor: ["clinic", "patients", "medical", "sell", "customers", "cameras"],
  nurse: ["clinic", "patients", "medical", "cameras"],
  receptionist: ["clinic", "patients", "sell", "customers", "cameras"],
};
export const ROLES_FOR = (shopType) => (shopType === "clinic" ? ["owner", "manager", "doctor", "nurse", "receptionist", "cashier"] : ["owner", "manager", "cashier"]);

export const can = (role, perm) => !perm || (ROLE_PERMS[role] || []).some((p) => p === "*" || p === perm);
export const isDenied = (staff, key) => !!staff && staff.role !== "owner" && (staff.denied || []).includes(key);
export const shopLocked = (shop, key) => !!shop && (shop.disabled_features || []).includes(key);
export const canStaff = (staff, perm, shop) => !!staff && can(staff.role, perm) && !isDenied(staff, `page:${perm}`) && !shopLocked(shop, `page:${perm}`);
export const canOp = (staff, type, shop) => !!staff && can(staff.role, OP_PERM[type]) && !isDenied(staff, type) && !shopLocked(shop, type) && !shopLocked(shop, `page:${OP_PERM[type]}`);

export const PERM_GROUPS = [
  { perm: "sell", ops: ["sale.create", "shift.open", "shift.close", "cash.move", "vault.move", "invoice.create", "favorites.update", "fx.trade", "fx.payout", "fx.transfer.report", "custom_order.upsert"] },
  { perm: "returns", ops: ["sale.return", "invoice.void", "fx.void"] },
  { perm: "customers", ops: ["customer.upsert", "payment.create"] },
  { perm: "inventory", ops: ["product.upsert", "product.delete", "stock.adjust", "price.bulk", "service.upsert", "service.delete", "waste.create", "waste.delete"] },
  { perm: "purchases", ops: ["supplier.upsert", "purchase.create", "supplier_payment.create", "expense.create", "order.upsert", "house.open", "house.close"] },
  { perm: "marketing", ops: ["promotion.upsert"] },
  { perm: "reports", ops: ["day.close"] },
  { perm: "clinic", ops: ["appointment.upsert"] },
  { perm: "patients", ops: ["patient.upsert"] },
  { perm: "medical", ops: ["encounter.upsert", "record.upsert"] },
  { perm: "bank", ops: ["bank.move", "bank.void"] },
  { perm: "cameras", ops: [] },
];

export const OP_PERM = {
  "sale.create": "sell",
  "customer.upsert": "customers",
  "payment.create": "customers",
  "product.upsert": "inventory",
  "product.delete": "inventory",
  "stock.adjust": "inventory",
  "waste.create": "inventory",
  "waste.delete": "inventory",
  "price.bulk": "inventory",
  "supplier.upsert": "purchases",
  "purchase.create": "purchases",
  "supplier_payment.create": "purchases",
  "sale.return": "returns",
  "expense.create": "purchases",
  "promotion.upsert": "marketing",
  "shop.update": "settings",
  "shift.open": "sell",
  "shift.close": "sell",
  "vault.move": "sell",
  "charity.payout": "settings",
  "cash.move": "sell",
  "shift.reopen": "settings",
  "invoice.create": "sell",
  "invoice.void": "returns",
  "house.open": "purchases",
  "house.close": "purchases",
  "day.close": "reports",
  "day.reopen": "settings",
  "fx.trade": "sell",
  "fx.payout": "sell",
  "fx.transfer.report": "sell",
  "fx.transfer.reconcile": "purchases",
  "fx.transfer.delete": "purchases",
  "bank.move": "bank",
  "bank.void": "bank",
  "fx.adjust": "purchases",
  "fx.void": "returns",
  "favorites.update": "inventory",
  "hr.event": "team",
  "hr.event.delete": "team",
  "patient.upsert": "patients",
  "appointment.upsert": "clinic",
  "encounter.upsert": "medical",
  "record.upsert": "medical",
  "service.upsert": "inventory",
  "service.delete": "inventory",
};
